module.exports = __webpack_public_path__ + "static/media/logo_ckf.a093c2ca.svg";